import React, { createContext, useContext, useEffect } from 'react';
import { useAuthStore, logout } from '../stores/authStore';
import { refreshAccessToken } from '../services/api';

const AuthContext = createContext(null);

/**
 * Reusable AuthProvider component managing startup session initialization and providing AuthContext.
 */
export function AuthProvider({ children }) {
  const authState = useAuthStore((s) => s);

  useEffect(() => {
    // Startup check: attempt session restore via HttpOnly refresh cookie
    const initSession = async () => {
      try {
        await refreshAccessToken();
      } catch {
        // Unauthenticated or refresh token expired
      }
    };
    initSession();
  }, []);

  const value = {
    ...authState,
    logout,
    refreshAccessToken,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

export default AuthProvider;
